import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { Pagination } from 'src/app/models/Pagination';
import { AsyncPaginatorData } from '../../classes/AsyncPaginatorData';

@Component({
	selector: 'app-async-mat-paginator',
	templateUrl: './async-mat-paginator.component.html',
	styleUrls: ['./async-mat-paginator.component.scss']
})
export class AsyncMatPaginatorComponent {

	// Este paginador está desconectado de la tabla que muestra los datos
	// Está para emitir datos sobre la posición del paginado y agarrarlos en el componente y consultar como corresponda
	// Todos los inputs y outputs son obligatorios, excepto pageSizeOptions y wrapper_classes

	@Input() pagination! : Pagination<any>;
	@Input() intl! : MatPaginatorIntl;
	@Input() bLoading! : boolean;
	@Input() pageSizeOptions = [10, 15, 20];
	@Input() wrapper_classes! : string;
	@ViewChild("paginator") paginator! : MatPaginator;
	@Output() eePageChange = new EventEmitter<AsyncPaginatorData>();

	ngAfterViewInit() {
		this.paginator._intl = this.intl;
	}

	onPageChange($event:PageEvent) {
		let apd = new AsyncPaginatorData($event.pageIndex+1, $event.pageSize);
		this.eePageChange.emit(apd);
	}
}
